import ApiClient from "@/utils/api-client";
export default {
  // 更新购物车商品议价信息
  updateCartBargainInfo(params?: any): any {
    return ApiClient.post(`/order/index/update_cart_bargain_info`, params);
  },
  // 取消购物车商品议价信息
  cancelCartBargainInfo(params?: any): any {
    return ApiClient.post(`/order/index/cancel_cart_bargain_info`, params);
  },
  getUserCart(params?: any): any {
    return ApiClient.get(`/order/mercari/get_user_cart`, params);
  },
  // get_user_cart
  // 获取用户购物车数量
  getUserCartNum(params?: any): any {
    return ApiClient.get(`/order/index/get_user_cart_num`, params);
  },
  // 获取用户购物车信息
  getUserCartList(params?: any): any {
    return ApiClient.get(`/order/index/get_user_cart_list`, params);
  },
  // 获取订单确认页面信息
  getUserCheckoutList(params?: any): any {
    return ApiClient.get(`/order/index/get_user_checkout_list`, params);
  },
  // 购物车列表选中商家全部订单
  getCheckSeller(params?: any): any {
    return ApiClient.get(`/order/index/check_seller`, params);
  },
  // 勾选商品
  getCheckGoods(params?: any): any {
    return ApiClient.get(`/order/index/check_goods`, params);
  },
  // 更新购物车中 检品服务状态
  updateGoodsSafety(params?: any): any {
    return ApiClient.get(`/order/index/update_goods_safety`, params);
  },
  // 更新购物车中商品备注
  updateGoodsNote(params?: any): any {
    return ApiClient.get(`/order/index/update_goods_note`, params);
  },
  updateOrderNote(params?: any): any {
    return ApiClient.get(`/order/index/update_order_note`, params);
  },
  // 更新购物车商品数量
  updateGoodsNum(params?: any): any {
    return ApiClient.get(`/order/index/update_goods_num`, params);
  },
  // 选中、取消全部
  getCheckAll(params?: any): any {
    return ApiClient.get(`/order/index/check_all`, params);
  },
  // 删除购物车中商品
  delCart(params?: any): any {
    return ApiClient.post(`/order/index/del_cart`, params);
  },
  delCartAll(params?: any): any {
    return ApiClient.post(`/order/index/del_cart_all`, params);
  },
  // 删除购物车（煤炉）已售出商品
  delCartSaled(params?: any): any {
    return ApiClient.post(`/order/index/del_cart_is_saled`, params);
  },
  // 提交订单
  cartSubmit(params?: any): any {
    return ApiClient.get(`/order/index/cart_submit`, params);
  },
  // 获取订单数量
  getOrderCounts(params?: any): any {
    return ApiClient.get(`/order/index/get_order_counts`, params);
  },
  // 获取订单列表
  getOrderList(params?: any): any {
    return ApiClient.get(`/order/index/get_order_list`, params);
  },
  // 获取订单详情
  getOrderInfo(params?: any): any {
    return ApiClient.get(`/order/index/get_order_info`, params);
  },
  // 删除已取消、订单
  delOrder(params?: any): any {
    return ApiClient.get(`/order/index/del_order`, params);
  },
  // 订单增加工单
  addWorkOrder(params?: any): any {
    return ApiClient.get(`/order/index/add_work_order`, params);
  },
  // 获取工单列表
  getWorkOrderList(params?: any): any {
    return ApiClient.get(`/order/index/get_work_order_list`, params);
  },
  // 获取工单详情
  getWorkOrderInfo(params?: any): any {
    return ApiClient.get(`/order/index/get_work_order_info`, params);
  },
  // 获取商品可选服务、购物车用
  getGoodsService(params?: any): any {
    return ApiClient.get(`/order/index/get_goods_service`, params);
  },
  // 更新购物车中商品服务信息
  updateGoodsService(params?: any): any {
    return ApiClient.post(`/order/index/update_cart_service`, params);
  },
  //代购商品（自助提交链接）加入购物车
  purchashingAddCart(params?: any): any {
    return ApiClient.post(`/order/purchashing/add_cart`, params);
  },
  //代购商品（自助提交链接）立即购买
  purchashingBuyNow(params?: any): any {
    return ApiClient.post(`/order/purchashing/buy_now`, params);
  },
  // 煤炉购买
  addCartMercari(params?: any): any {
    return ApiClient.get(`/order/mercari/add_cart`, params);
  },

  // Yahoo!フリマ商品加入购物车
  addCartYahooPaypay(params?: any): any {
    return ApiClient.get(`/order/yahoo_paypay/add_cart`, params);
  },

  /**
   * Rakuten乐天商品加入购物车
   * @param params
   * @returns
   */
  addCartRakuten(params?: any): any {
    return ApiClient.post(`/order/rakuten/add_cart`, params);
  },
  // 直接购买
  buyNowMercari(params?: any): any {
    return ApiClient.get(`/order/mercari/buy_now`, params);
  },
  // Yahoo!フリマ商品立即购买
  buyNowYahooPaypay(params?: any): any {
    return ApiClient.get(`/order/yahoo_paypay/buy_now`, params);
  },
  // 获取商品可选服务、订单用
  getOrderGoodsService(params?: any): any {
    return ApiClient.get(`/order/index/get_order_list_goods_service`, params);
  },
  // 更新订单中商品服务信息
  updateOrderGoodsService(params?: any): any {
    return ApiClient.post(`/order/index/update_goods_service`, params);
  },
  // 更新订单商品议价信息
  updateOrderBargainInfo(params?: any): any {
    return ApiClient.post(`/order/index/update_bargain_info`, params);
  },
  // 取消订单商品议价信息
  cancelOrderBargainInfo(params?: any): any {
    return ApiClient.post(`/order/index/cancel_bargain_info`, params);
  },
  // 取消订单
  cancelOrder(params?: any): any {
    return ApiClient.post(`/order/index/del_order`, params);
  },
  // 议价取消订单
  bargainCancelOrder(params?: any): any {
    return ApiClient.post(`/order/index/bargain_cancel_order`, params);
  },
  // 议价同意卖家金额
  bargainSellerAmount(params?: any): any {
    return ApiClient.post(`/order/index/bargain_seller_amount`, params);
  },
  // 议价同意卖家金额
  bargainBuyWidthOriginalPrice(params?: any): any {
    return ApiClient.post(
      `/order/index/bargain_buy_width_original_price`,
      params
    );
  },
};
